import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import TaxPlanning from "@/pages/TaxPlanning";
import IndividualTax from "@/pages/IndividualTax";
import BusinessFormation from "@/pages/BusinessFormation";
import IRSNotices from "@/pages/IRSNotices";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";

const queryClient = new QueryClient();

function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background" style={{ fontFamily: "Inter, 'Noto Sans KR', system-ui, sans-serif" }}>
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/tax-planning" element={<TaxPlanning />} />
          <Route path="/individual-tax" element={<IndividualTax />} />
          <Route path="/business-formation" element={<BusinessFormation />} />
          <Route path="/irs-notices" element={<IRSNotices />} />
          <Route path="/about" element={<About />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <LanguageProvider>
        <HashRouter>
          <SiteLayout />
        </HashRouter>
      </LanguageProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
